<template>
  <div class="pb-32" v-if="!$h.empty(order)">
    <product-info :groupon="order.groupon" />
    <div class="qr mt-2 bg-white border-t border-b p-4">
      <div class="text-gray-600 text-center">验证码：{{ order.code }}</div>
      <div class="flex justify-between flex-col items-center">
        <qriously :value="order.code" :size="100"/>
      </div>
    </div>
    <seller-info :seller="order.seller" />
    <groupon-desc :desc="order.groupon.desc" />
    <order-info :order="order" />
    <van-dialog
      v-model="show"
      :showConfirmButton="true"
      confirmButtonText="关闭"
    >
      <div class="text-center p-4">
        <div class="title text-2xl font-bold mb-4">还差 <span class="text-ls-800">{{ order.groupon.min - order.notSuccessUsers.length }}</span> 人成团</div>
        <div class="text-sm text-gray-600 mb-4">剩余：{{ order.success_left }}</div>
        <button @click="share" class="bg-ls-800 w-full py-2 px-4 mb-4 text-white">邀请好友拼单</button>
        <div class="text-teal-300 text-sm mb-4">分享到三个群后，成团率高达 98%</div>
        <div class="flex flex-row items-center">
          <div
            v-for="(user, index) in order.notSuccessUsers"
            :key="user.id"
            class="mr-1 relative w-12 h-12">
            <img :src="user.avatar" :alt="user.nickname" class="rounded-full w-12 h-12">
            <div v-if="index === 0" class="text-xs bg-ls-800 text-white absolute rounded-lg border" style="bottom: 0; left: 5px; right: 5px;">团长</div>
          </div>
          <div
            v-for="i in (order.groupon.min - order.notSuccessUsers.length)"
            :key="i"
            class="mr-1 rounded-full border border-dashed w-12 h-12 items-center flex">
            <div class="text-center mx-auto">?</div>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
import ProductInfo from '@/components/ProductInfo'
import GrouponDesc from '@/components/GrouponDesc'
import OrderInfo from '@/components/OrderInfo'
import SellerInfo from '@/components/SellerInfo'
export default {
  components: {
    ProductInfo,
    GrouponDesc,
    OrderInfo,
    SellerInfo
  },
  data () {
    return {
      show: false,
      order: ''
    }
  },
  computed: {
    wxReady () {
      return this.$store.state.wxReady
    },
    id () {
      return this.$route.params.id
    },
    loading () {
      return this.$store.state.loading
    },
    issuccess () {
      return !this.order.successed_at && !this.order.refund_at && !this.order.closed_at
    }
  },
  created () {
    this.$toast.loading({
      duration: 0
    })
    this.fetch()
    if (this.wxReady && !this.$h.empty(this.order)) {
      this.shareInfo()
    }
  },
  methods: {
    shareInfo () {
      let that = this
      wx.updateAppMessageShareData({
        title: that.order.groupon.title, // 分享标题
        desc: that.order.groupon.title, // 分享描述
        link: 'https://m.yooshifu.com/groupon.html?#/groupons/' + that.order.groupon.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: that.order.groupon.images[0].image, // 分享图标
        success: function () {
        }
      })
    },
    fetch () {
      this.$http.get(this.$api.orders + '/' + this.id).then(res => {
        this.$toast.clear()
        let { status, data } = res
        if (status) {
          this.$h.handleError(res)
          this.$router.go(-1)
        }
        this.order = data
        this.show = !this.order.successed_at && !this.order.refund_at && !this.order.closed_at
        this.$store.commit('updateGroupon', data.groupon)
      })
    }, // end of fetch
    share () {
      this.show = false
      this.$router.push('/share/' + this.order.groupon.id)
    }
  } // end of methods
}
</script>
